import { useRef } from "react";
import { getRandomString } from "../utils/getIds";

export function useRandomId() {
  let id = useRef(getRandomString());

  return id.current;
}
